import React from 'react';
import QRCode from "react-qr-code";
import { mediaData } from '../data/mediaData';

const QRWrapper = ({ qrUrl, isClose = false, onClose = () => {} }) => {
    return (
        <div className='qr-code-wrapper-main'>
            <div className='qr-code-wrapper side-panel-col'>
                <div className="try-on-phone-wrapper">
                    <div className="try-on-qr-wrapper">
                        <span>
                            <QRCode
                                size={400}
                                bgColor="#E0E6F2"
                                fgColor="#313C5A"
                                style={{
                                    height: "100%",
                                    maxWidth: "100%",
                                    width: "100%",
                                }}
                                value={qrUrl}
                                viewBox={`0 0 400 400`}
                            />
                        </span>
                    </div>
                    <div className="small-text">
                        Scan this QR code on your phone for a better
                        experience
                    </div>
                </div>
            </div>
            {isClose ? <img className='qr-code-wrapper-close' src={mediaData['closeIconModal']} width={20} onClick={onClose} /> : null }
        </div>
    )
}

export default QRWrapper